import apiUtil from "./apiUtils";
import request from "superagent";
// import jwt_decode from 'jwt-decode';

let baseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  "https://pfra.gov.np/admin/api";

// let baseUrl = "http://192.168.1.87:8000/api";

const urls = [
  "/questionapi.php", // form data
  "/responsedataentry.php", //submit response,
  "/fileupload.php",
  "optionsapi.php", //previous answers
  "datalg.php", //dashboard
];
let api = new apiUtil(baseUrl);
console.log("first API", api);
class Api {

  async login(body = {}) {
    try {
      let response = await api.post("/login", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async sendResponse(body = {}) {
    try {
      let response = await api.post("/answers", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async sendMinistryResponse(body = {}) {
    try {
      let response = await api.post("/ministry_answers", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async submitStage(body = {}) {
    try {
      let response = await api.post("/submit_stage", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async submitMinistryStage(body = {}) {
    try {
      let response = await api.post("/submit_ministry_stage", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async submitProvincialStage(body = {}) {
    try {
      let response = await api.post("/change_status", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async submitCAOApprove(body = {}) {
    try {
      let response = await api.post("/cao_approve", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async Answers(body = {}) {
    try {
      let response = await api.get(`/optionsapi.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async ministryAnswers(body = {}) {
    try {
      let response = await api.get(`/checkministryanswer`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getQuestions(fiscal_year_id, province_id, ocmcm_id) {
    try {
      let response = await api.get(`/questions`, {
        fiscal_year_id: fiscal_year_id,
        province_id: province_id,
        ocmcm_id: ocmcm_id,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getMinistryQuestions(fiscal_year_id, province_id, ministry_id) {
    try {
      let response = await api.get(`/ministry_questions`, {
        fiscal_year_id: fiscal_year_id,
        province_id: province_id,
        ministry_id: ministry_id,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getComments(fiscal_year_id, question_id, ministry_id) {
    try {
      let response = await api.get(`/comments`, {
        fiscal_year_id: fiscal_year_id,
        question_id: question_id,
        ministry_id: ministry_id,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getProvincialComments(fiscal_year_id, question_id, ocmcm_id) {
    try {
      let response = await api.get(`/ocmcm/comments`, {
        fiscal_year_id: fiscal_year_id,
        question_id: question_id,
        ocmcm_id: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
          : sessionStorage.getItem("provinceId"),
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getInternalQuestions(fiscal_year_id, province_id, gnid) {
    try {
      let response = await api.get(`/internal_questions`, {
        fiscal_year_id: fiscal_year_id,
        province_id: province_id,
        ministry_id: gnid,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async submitInternalAnswer(fiscal_year_id, gnid) {
    try {
      let response = await api.get(`/internal_questions`, {
        fiscal_year_id: fiscal_year_id,
        province_id: sessionStorage.getItem("province_id"),
        ministry_id: gnid,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async submitInternalMarks(body = {}) {
    try {
      let response = await api.post("/internal_marks", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async publishInternalAnswer(body = {}) {
    try {
      let response = await api.post("/internal_marks/publish", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async getDetail(fiscal_year_id, gnid, ministry_id) {
    try {
      let response = await api.get(`/local`, {
        fiscal_year_id: fiscal_year_id,
        province_id: gnid,
        ministry_id: ministry_id,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getDocumentsList(body = {}) {
    try {
      let response = await api.get(`/documents`, body); //get docs by fy id
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getMinistryDocumentsList(body = {}) {
    try {
      let response = await api.get(`/ministry_documents`, body); //get docs by fy id
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getMap(body = {}) {
    try {
      let response = await api.get(`/mapapi.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getProvincialData(body = {}) {
    try {
      let response = await api.get(`/dashboard/get_active_status`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getProvinceMap() {
    try {
      let response = await api.get(`/provinces`);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getPalikaMap(gnid) {
    try {
      let response = await api.get(`/palikas/${gnid}`);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getAllPalikaMap(gnid) {
    try {
      let response = await api.get(`/palikas`);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getProvinceData(fiscal_year_id) {
    try {
      let response = await api.get(`/dashboard/all`, {
        fiscal_year_id: fiscal_year_id,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getOcmcmProvinceData(fiscal_year_id) {
    try {
      let response = await api.get(`/dashboard/ocmcm`, {
        fiscal_year_id: fiscal_year_id,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getNepalProvinceData(body = {}) {
    try {
      let response = await api.get(`/frontdatanep.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getLocalData(body = {}) {
    try {
      let response = await api.get(`/frontdatalg.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getNepalProvinceData(body = {}) {
    try {
      let response = await api.get(`/frontdatanep.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getLocalData(body = {}) {
    try {
      let response = await api.get(`/frontdatalg.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getProvinceList() {
    try {
      let response = await api.get(`/provinces`);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getOcmcmList() {
    try {
      let response = await api.get(`/ocmcms`);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getDistrictList(provinceId) {
    try {
      let response = await api.get(`/districts`, { province_id: provinceId });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getPalikaList(districtId) {
    try {
      let response = await api.get(`/palikas`, { district_id: districtId });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getHomeData(body = {}) {
    try {
      let response = await api.get(`/home`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getHomeBarData(body = {}) {
    try {
      let response = await api.get(`/ocmcm_detail`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getOcmcmHomeData(body = {}) {
    try {
      let response = await api.get(`/ocmcm_home`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getMinistryHomeData(body = {}) {
    try {
      let response = await api.get(`/data_home`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async downloadMinistryReport(fiscal_year_id, province_id) {
    try {
      let response = await api.get(
        `/dashboard/downloadMinistry?fiscal_year_id=${fiscal_year_id}&province_id=${province_id}`
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async downloadministrydownload(fiscal_year_id, province_id, ministry_id) {
    try {
      let response = await api.get(
        `/ministry_download?fiscal_year_id=${fiscal_year_id}&province_id=${province_id}&ministry_id=${ministry_id}`
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async uploadDocument(files, fiscalYear, token, id, gnid) {
    const res = await request
      .post(`${baseUrl}/uploads`)
      .attach("path", files[0])
      .field("fiscal_year_id", fiscalYear)
      .field("document_id", id)
      .field("ministry_id", gnid)
      .set("Authorization", "Bearer " + token)
      .accept("application/json");
    let responseJson = JSON.parse(res.text);
    return responseJson;
    // files.forEach(file => {
    //   req.attach('file', file);
    // });
    // for (var field in fields) {
    //     req.field(field, fields[field]);
    // }
    // req.end(function(err, res){
    //     if (res.ok) {
    //         return JSON.parse(res.text);
    //     }
    // });
  }

  async uploadProvincialDocument(files, fiscalYear, token, id, gnid) {
    const res = await request
      .post(`${baseUrl}/uploads`)
      .attach("path", files[0])
      .field("fiscal_year_id", fiscalYear)
      .field("document_id", id)
      .field("ocmcm_id", gnid)
      .set("Authorization", "Bearer " + token)
      .accept("application/json");
    let responseJson = JSON.parse(res.text);
    return responseJson;
  }

  async setDocumentRemarks(body = {}) {
    try {
      let response = await api.post("/update_remarks", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async setOcmcmDocumentRemarks(body = {}) {
    try {
      let response = await api.post("/updateOcmcm_remarks", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getIndividualDashboard(body = {}) {
    try {
      let response = await api.get(`/answers`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getLocalDashboard(fiscal_year_id, ministry_id) {
    try {
      let response = await api.get(`/dashboard/local`, {
        fiscal_year_id: fiscal_year_id,
        ministry_id: ministry_id,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getDistrictDashboard(fiscal_year_id, gnid) {
    try {
      let response = await api.get(`/reports/ministry_progress`, {
        fiscal_year_id: fiscal_year_id,
        province_id: gnid,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getDistrict(province_id) {
    try {
      let response = await api.get(`/districts`, { province_id: province_id });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getCategories(body = {}) {
    try {
      let response = await api.get(`/categories`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getMinistryCategories(body = {}) {
    try {
      let response = await api.get(`/ministry_categories`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async getSubCategories(body = {}) {
    try {
      let response = await api.get(`/sub_categories`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getSingleLocalData(body = {}) {
    try {
      let response = await api.get(`/datasinglelg.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getReportData(body = {}) {
    try {
      let response = await api.get(`/reports/summary`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async verifyForm(body = {}) {
    try {
      let response = await api.get(`/dataverification.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async deleteFile(body = {}) {
    try {
      let response = await api.post("/deletefile.php", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getDropdown() {
    try {
      let response = await api.get(`/dropdownapi.php`);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async sendRemarks(body = {}) {
    try {
      let response = await api.post("/remarks.php", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getCatDocuments(body = {}) {
    try {
      let response = await api.get(`/documentlist.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async checkSubmit(body = {}) {
    try {
      let response = await api.get(`/submitapi.php`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async getOcmcmHomeYekData(fiscal_year_id) {
    try {
      let response = await api.get(
        `/ocmcm_nepal_score?fiscal_year_id=${fiscal_year_id}`
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getFyList() {
    try {
      let response = await api.get(`/fiscal_years`);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async approveAnswers(body = {}) {
    try {
      let response = await api.post("/uploads/delete", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async postComments(body = {}) {
    try {
      let response = await api.post("/comments", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteComment(id) {
    try {
      let response = await api.delete(
        `/comments/${id}`, {}
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async removeMov(body = {}) {
    try {
      let response = await api.post("/uploads/delete", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async removeOcmcmMov(body = {}) {
    try {
      let response = await api.post("/uploadsOcmcm/delete", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async updateFormStatus(body = {}) {
    try {
      let response = await api.post("/change_status", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async changeStatus(body = {}) {
    try {
      let response = await api.post("/submit_stage", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async getUsers(body = {}) {
    try {
      let response = await api.get(`/users`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getUserDetail(id) {
    try {
      let response = await api.get(`/users/${id}`, {});
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async createUser(body = {}) {
    try {
      let response = await api.post("/add_user", {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async deactivateUser(id) {
    try {
      let response = await api.get(`/deactivate_user/${id}`, {});
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUser(user) {
    try {
      let response = await api.post(`/update_user/${user.id}`, {
        body: user,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async updateProfile(body = {}) {
    try {
      let response = await api.post(`/update_profile`, {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async getProfile(body = {}) {
    try {
      let response = await api.get(`/profile`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async changeOwnPassword(body = {}) {
    try {
      let response = await api.post(`/change_password`, {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async updateFormStatusFinal(files, fields = {}) {
    const res = await request
      .post(`${baseUrl}/change_status`)
      .attach("file", files[0])
      .field("fiscal_year_id", fields["fiscal_year_id"])
      .field("status", fields["status"])
      .set("Authorization", "Bearer " + fields.user_token)
      .accept("application/json");
    let responseJson = JSON.parse(res.text);
    return responseJson;
  }

  async getPalikaDetailStiti(body = {}) {
    try {
      let response = await api.get(`/reports/ministry_progress`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async changePassword(user, body = {}) {
    try {
      let response = await api.post(`/change_user_password/${user.id}`, {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }

  async resetExpirePassword(code, body = {}) {
    try {
      let response = await api.post(`/reset_expired_password/${code}`, {
        body,
      });
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async getMinistryReport(
    fiscal_year_id,
    province_id,
    ministry_id,
    category_id
  ) {
    try {
      let response = await api.get(
        `/ministry_report?fiscal_year_id=${fiscal_year_id}&province_id=${province_id}&category_id=${category_id}&ministry_id=${ministry_id}`
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }
  async getNonMinistryReport(
    fiscal_year_id,
    province_id,
    ocmcm_id,
    category_id
  ) {
    try {
      let response = await api.get(
        `/ocmcm_report?fiscal_year_id=${fiscal_year_id}&province_id=${province_id}&ocmcm_id=${ocmcm_id}&category_id=${category_id}`
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async downloadreportyek(fiscal_year_id, province_id, ocmcm_id) {
    try {
      let response = await api.get(
        `/download?fiscal_year_id=${fiscal_year_id}&province_id=${province_id}&ocmcm_id=${ocmcm_id}`
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(error);
    }
  }
  async getPalikaSuspendedUsers(body = {}) {
    try {
      let response = await api.get(`/suspended_users`, body);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async restoreUser(id) {
    try {
      let response = await api.get(`/restore_user/${id}`, {});
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }


  async getAllComments(f_id, ministry_id, ocmcm_id) {
    try {
      let response = null;
      if (ministry_id) {
        response = await api.get(`/ministry_comment`, {
          fiscal_year_id: f_id, ministry_id: ministry_id
          // , all: 1
        });
      }
      else {
        response = await api.get(`/ocmcm_comment`, {
          fiscal_year_id: f_id, ocmcm_id: ocmcm_id
          // , all: 1
        })
      }
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getAllCommentsForPrint(f_id, ministry_id, ocmcm_id) {
    try {
      let response = null;
      if (ministry_id) {
        response = await api.get(`/ministry_comment`, {
          fiscal_year_id: f_id, ministry_id: ministry_id
        });
      }
      else {
        response = await api.get(`/ocmcm_comment`, {
          fiscal_year_id: f_id, ocmcm_id: ocmcm_id
        })
      }
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async getComments(f_id, q_id, ministry_id, ocmcm_id) {
    try {
      let response = null;
      if (ministry_id) {
        response = await api.get(`/ministry_comment_question`, { fiscal_year_id: f_id, question_id: q_id, ministry_id: ministry_id });
      }
      else {
        response = await api.get(`/ocmcm_comment_question`, { fiscal_year_id: f_id, question_id: q_id, ocmcm_id: ocmcm_id });
      }
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

  async editComment(body = {}, id) {
    try {
      let response = await api.put(
        `/comments/${id}`, {
        body
      }
      );
      let responseJson = await response.json();
      return responseJson;
    }
    catch (error) {
      throw error;
    }
  }

  async postComment(body = {}) {
    try {
      let response = await api.post(
        '/comments', {
        body
      }
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw error;
    }
  }

}

export default new Api();
